import * as React from 'react';
import { observer, inject } from 'mobx-react';
import IStore, { DONE } from './store';
import { saveAs } from 'file-saver';
import StyledApp from './app.styled';
import Dropzone from './dropzone';
import { READY, PROCESSING } from './store';

const ucfirst = (str: string): string => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

@inject('propStore')
@observer
class App extends React.Component<any, IStore> {
	constructor(props: IStore) {
		super(props);
	}

	get injected() {
		return this.props.propStore as IStore;
	}

	public download = () => {
		const { startDate, endDate, source, status } = this.injected;
		if (status !== DONE) {
			alert('Upload csv file first!');
			return false;
		}
		const blob = new Blob([this.injected.result], {
			type: 'text/csv;charset=utf-8',
		});
		const downloadName = `${source}_cpc_${startDate}-${endDate}.csv`;
		saveAs(blob, downloadName);
		this.injected.addHistory(downloadName);
	};

	public updateSource = e => {
		const {
			update,
			startConvert
		} = this.injected;
		update({
			source: e.target.value,
		});
		startConvert();
	};

	public render() {
		const {
			download,
			updateSource,
			injected: {
				enabled,
				source,
				status,
				schema,
				updateSchema,
				startConvert,
				reset,
				addJob,
				showSelectPlatform,
			},
		} = this;
		if (!enabled) {
			return null;
		}
		return (
			<StyledApp>
				<div className="container">
					<h1>비용데이터 변환기</h1>
					<h2>
						for{' '}
						<a href="https://analytics.google.com" target="_blank">
							google analytics
						</a>
					</h2>
					<p className="lead">
						각 사이트 광고관리자에서 추출한 데이터를
						구글분석기에 손쉽게 삽입할 수 있도록 변환기능을 제공합니다.
						주기적으로 이 도구를 방문하여 GA에 지출정보를
						업데이트하세요.
					</p>

					<div id="app-form" className="form">

						<div className="form-group">
							<label
								htmlFor=""
								className="control-label"
							>
								추출된 데이터 업로드
							</label>
							<Dropzone
								reset={reset}
								addJob={addJob}
								startConvert={startConvert}
							/>
						</div>

						{showSelectPlatform &&
							<div className="form-group">
								<label
									htmlFor="schema"
									className="control-label"
								>
									플랫폼 선택
								</label>
								{['naver', 'facebook'].map(sn => (
									<div key={sn} className="radio">
										<label>
											<input
												type="radio"
												name={source}
												id="input"
												value={sn}
												checked={source === sn}
												onChange={updateSource}
											/>
											{ucfirst(sn)}
										</label>
									</div>
								))}
							</div>
						}

						{/*
						<div className="form-group">
							<label
								htmlFor="schema"
								className="control-label"
								data-num="3"
							>
								스키마 확인
							</label>
							<textarea
								name="schema"
								className="form-control"
								value={schema[source]}
								placeholder="GA data scheme. ex)ga:date,ga:medium,ga:source,ga:impressions..."
								onChange={updateSchema}
							/>
						</div>
						*/}

						{status !== READY &&
							<div className="form-group">
								<label
									htmlFor=""
									className="control-label"
								>
									생성된 데이터 다운로드
								</label>
								<button
									className={`btn btn-primary btn-block btn-lg status-${status}`}
									onClick={download}
								>
									{status === READY && 'Waiting uploading..'}
									{status === PROCESSING && '.. Converting ..'}
									{status === DONE && 'Data Import를 위해 파일 다운로드'}
								</button>
							</div>
						}
					</div>

					<div className="copyright">
						Powered by{' '}
						<a href="https://tyle.io?utm_source=tyle&utm_campaign=tools&utm_medium=gh">
							tyle.io
						</a>
					</div>
				</div>
			</StyledApp>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/app.tsx